import { css } from '@emotion/css'
import { spacing } from '@offerzen/pinata'

const iconWidth = 20

const styles = {
  body: css({
    flexDirection: 'column',
    padding: spacing.medium,

    '> * + *': {
      marginTop: spacing.default,
    },
  }),

  title: css({
    display: 'flex',
    alignItems: 'center',

    '> * + *': {
      marginLeft: spacing.small,
    },
  }),

  cities: css({
    marginLeft: iconWidth + spacing.small,
  }),

  list: css({
    marginBottom: 0,
    padding: 0,
    listStyle: 'none',
  }),
}

export default styles
